import img from '@/assets/images/timeRule.png'
// 国内
const introduceA = [
  {
    type: 'weight',
    label: '重量说明',
    content: `<div><p>即日专递、特快专递：</p><span>单件邮件最大重量不超过40千克。</span></div><div><p>标准快递、电商标快：</p><span>单件邮件最大重量不超过30千克。</span></div><div><p>快递包裹：</p><span>单件邮件最大重量不超过20千克。</span></div>`
  },
  {
    type: 'protect',
    label: '保价说明',
    // content: `<div><p>即日专递、特快专递、标准快递:</p><span>1、按交寄文件、物品的声明价值保价，声明价值在300元(含)内的，保价费按1元收取;声明价值超过300元的部分按照千分之五费率收取保费(保价费最低收取1元人民币)。<br />2、单件交寄物的价值限定为5万元。<br />3、以快递员实际收取为准。</span></div><div><p>快递包裹:</p><span>1.按交寄文件、物品的声明价值保价，声明价值在300元(含)以内的，保价费按1元收取;声明价值超过300元的部分，按照千分之十费率收取保费 (保价费最低收取1元人民)。<br />2.单件交寄物的价值限定为2万元。<br />3.以快递员实际收取为准。</span></div>`
    content: `<div>1.按照交寄文件、物品的声明价值保价，基础保收费标准为：保价500元（含）以下收取1元，保价500-1000元（含）收取2元，保价1000元以上按保价金额的5&permil;收取。如需投保&ldquo;文件保&rdquo;或&ldquo;全额保&rdquo;，请在下单界面进行选择。</span></div><div><span>2.单件交寄物的价值限定为即日专递、特快专递为50万元人民币，标准快递为5万元，快递包裹为3万元。</span></div><div><span>3.请以快递员实际收取为准。</span></div>`
  },
  {
    type: 'volume',
    label: '计泡说明',
    content: `<div><p>计泡是指对包装后的邮件，取体积重量和实际重量中的较大者，作为计费重量，再按照资费标准计算应收费用，体积重量的计算方式为：</p></div><div><p>即日专递、特快专递：</p><span>对交寄的物品长、宽、高三边中任一单边达到60cm的特快物品进行计泡，计泡系数为6000，计泡公式：体积重量（kg）=长（cm）*宽（cm）*高（cm）/计泡系数。</span></div><div><p>标准快递、电商标快：</p><span>对交寄长、宽、高三边之和大于100cm的标快、电商标快邮件进行计泡，计泡系数为5000/8000，计泡公式：体积重量（kg）=长（cm）*宽（cm）*高（cm）/计泡系数。</span></div><div><p>快递包裹：</p><span>对交寄的物品长、宽、高三边之和大于100cm的快递包裹进行计泡，计泡系数为5000/8000，计泡公式：体积重量（kg）=长（cm）*宽（cm）*高（cm）/计泡系数。</span></div>`
  }
]

const emsTab = {
  type: 'ems',
  label: 'ems高铁急送',
  content: `<img 
      src="${img}" 
      style="width:100%; max-width:400px; height:auto; display:block;" 
    />`
}

// 港澳台
const introduceB = [
  {
    type: 'weight',
    label: '重量说明',
    // content: `<div><p>港澳台特快专递：</p><span>寄澳门单件邮件最大重量不超过31.5千克，寄香港、台湾单件邮件最大重量不超过30千克。</span></div><div><p>港澳台航空包裹：</p><span>寄澳门单件邮件最大重量不超过31.5千克，寄香港、台湾单件邮件最大重量不超过30千克。</span></div><div><p>港澳台水陆路包裹：</p><span>寄澳门单件邮件最大重量不超过31.5千克，寄香港、台湾单件邮件最大重量不超过30千克。</span></div>`
    content: `<div><p>港澳台特快专递：</p><span>根据寄往地区路向不同，以实际收寄要求为准，具体地区路向限重详情可前往中国邮政速递物流官网产品服务<a href="https://www.ems.com.cn/hmt_express">https://www.ems.com.cn/hmt_express</a> 查看。</span></div><div><p>港澳台航空包裹：</p><span>根据寄往地区路向不同，以实际收寄要求为准，具体地区路向限重详情可前往中国邮政速递物流官网产品服务<a href="https://www.ems.com.cn/hmt_parcel">https://www.ems.com.cn/hmt_parcel</a> 查看。</span></div><div><p>港澳台水陆路包裹：</p><span>根据寄往地区路向不同，以实际收寄要求为准，具体地区路向限重详情可前往中国邮政速递物流官网产品服务<a href="https://www.ems.com.cn/hmt_parcel">https://www.ems.com.cn/hmt_parcel</a> 查看。</span></div>`
  },
  {
    type: 'protect',
    label: '保价说明',
    content: `<div><p>港澳台特快专递：</p><span>寄件人按交寄物的外币申报价值折算为人民币声明价值予以保价（以当天汇率折算为人民币，最高不超过2万元），保价费率按声明价值的千分之八收取，最低收取1元人民币。</span></div><div><p>港澳台航空包裹：</p><span>中国香港、中国澳门：寄件人按交寄物的外币申报价值折算为人民币声明价值予以保价（以当天汇率折算为人民币，最高不超过1万元）。<span style="color: #F5222D;">中国台湾：不提供保价。</span></span></div><div><p>港澳台水陆路包裹：</p><span>中国香港、中国澳门：寄件人按交寄物的外币申报价值折算为人民币声明价值予以保价（以当天汇率折算为人民币，最高不超过1万元）。<span style="color: #F5222D;">中国台湾：不提供保价。</span></span></div>`
  },
  {
    type: 'volume',
    label: '计泡说明',
    content: `<div><p>计泡是指对包装后的邮件，取体积重量和实际重量中的较大者，作为计费重量，再按照资费标准计算应收费用，体积重量的计算方式为：</p></div><div><p>港澳台特快专递：</p><span>对交寄的物品长、宽、高三边中任一单边达到40cm的特快物品进行计泡，计泡系数为6000，计泡公式：体积重量（kg)=长（cm)*宽（cm)*高（cm)/计泡系数，测量邮件的长、宽、高测量值精确到厘米，厘米以下去零取整。</span></div><div><p>港澳台航空包裹：</p><span>无计泡</span></div><div><p>港澳台水陆路包裹：</p><span>无计泡</span></div>`
  }
  // {
  //   type: 'product',
  //   label: '产品服务介绍',
  //   content: ``
  // }
]

// 国际
const introduceC = [
  {
    type: 'weight',
    label: '重量说明',
    content: `<div><p>国际特快专递：</p><span>根据寄往国家路向不同，以实际收寄要求为准，具体国家限重详情可前往中国邮政速递物流官网产品服务<a href="https://www.ems.com.cn/international_speedpost">https://www.ems.com.cn/international_speedpost</a> 查看。</span></div><div><p>国际水陆路包裹：</p><span>根据寄往国家路向不同，以实际收寄要求为准，具体国家限重详情可前往中国邮政速递物流官网产品服务<a href="https://www.ems.com.cn/international_parcel">https://www.ems.com.cn/international_parcel</a> 查看。</span></div><div><p>国际航空包裹：</p><span>根据寄往国家路向不同，以实际收寄要求为准，具体国家限重详情可前往中国邮政速递物流官网产品服务<a href="https://www.ems.com.cn/international_parcel">https://www.ems.com.cn/international_parcel</a> 查看。</span></div><div><p>国际空运水陆路包裹：</p><span>根据寄往国家路向不同，以实际收寄要求为准，具体国家限重详情可前往中国邮政速递物流官网产品服务<a href="https://www.ems.com.cn/international_parcel">https://www.ems.com.cn/international_parcel</a> 查看。</span></div>`
  },
  {
    type: 'protect',
    label: '保价说明',
    content: `<div><p>国际特快专递：</p><span>寄件人按交寄物的外币申报价值折算为人民币声明价值予以保价（以当天汇率折算为人民币，最高不超过2万元），保价费率按声明价值的千分之八收取，最低收取1元人民币。</span></div><div><p>国际水陆路包裹：</p><span>国际水陆路保价包裹只限寄往与我国互相通达此类包裹的国家和地区，寄件人按交寄物的外币申报价值折算为人民币声明价值予以保价（以当天汇率折算为人民币），我国每件保价包裹的保价限额为人民币1万元，当我国与寄达国或地区的保价限额不一致时，应以其中最低的保价限额为准。当相关保价包裹需经由第三方邮政散寄经转时，执行我邮政、寄达邮政和散寄经转邮政中最低的保价限额（与我国另有双边协议的，按协议规定的限额办理）</span></div><div><p>国际航空包裹：</p><span>国际航空保价包裹只限寄往与我国互相通达此类包裹的国家和地区，寄件人按交寄物的外币申报价值折算为人民币声明价值予以保价（以当天汇率折算为人民币），我国每件保价包裹的保价限额为人民币1万元，当我国与寄达国或地区的保价限额不一致时，应以其中最低的保价限额为准。当相关保价包裹需经由第三方邮政散寄经转时，执行我邮政、寄达邮政和散寄经转邮政中最低的保价限额（与我国另有双边协议的，按协议规定的限额办理）</span></div><div><p>国际空运水陆路包裹：</p><span>国际空运水陆路保价包裹只限寄往与我国互相通达此类包裹的国家和地区，寄件人按交寄物的外币申报价值折算为人民币声明价值予以保价（以当天汇率折算为人民币），我国每件保价包裹的保价限额为人民币1万元，当我国与寄达国或地区的保价限额不一致时，应以其中最低的保价限额为准。当相关保价包裹需经由第三方邮政散寄经转时，执行我邮政、寄达邮政和散寄经转邮政中最低的保价限额（与我国另有双边协议的，按协议规定的限额办理）</span></div>`
  },
  {
    type: 'volume',
    label: '计泡说明',
    content: `<div><p>计泡是指对包装后的邮件，取体积重量和实际重量中的较大者，作为计费重量，再按照资费标准计算应收费用，体积重量的计算方式为：</p></div><div><p>国际（地区）特快专递：</p><span>对交寄的物品长、宽、高三边中任一单边达到40cm的特快物品进行计泡，计泡系数为6000，计泡公式：体积重量（kg)=长（cm)*宽（cm)*高（cm)/计泡系数，测量邮件的长、宽、高测量值精确到厘米，厘米以下去零取整。</span></div><div><p>国际航空包裹：</p><span>无计泡</span></div><div><p>国际水陆路包裹：</p><span>无计泡</span></div><div><p>国际空运水陆路包裹：</p><span>无计泡</span></div>`
  }
]

const obj = {
  land: introduceA,
  sar: introduceB,
  int: introduceC,
  emsTab
}
export default obj
